let OBJECT_TYPES = [
  { 
    name: 'Organizations',
    fieldName: 'deltaOrgs',
    label: 'ORGANIZATIONS',
    displaySwitch: false,
    threshold: null,
    active: true,
    paginationValue: null,
    importToBeDeleted: false,
    isOneRosterApi: false,
    replaceModeEnabled: false
  },
  {
    name: 'Users',
    fieldName: 'deltaUsers',
    label: 'USERS',
    displaySwitch: false,
    threshold: null,
    active: true,
    paginationValue: null,
    importToBeDeleted: false,
    isOneRosterApi: false,
    replaceModeEnabled: false
  },
  {
    name: 'Courses',
    fieldName: 'deltaCourses',
    label: 'COURSES',
    displaySwitch: true,
    threshold: null,
    active: true,
    paginationValue: null,
    importToBeDeleted: false,
    isOneRosterApi: false,
    replaceModeEnabled: false
  },
  {
    name: 'Classes',
    fieldName: 'deltaClasses',
    label: 'CLASSES',
    displaySwitch: true,
    threshold: null,
    active: true,
    importToBeDeleted: false,
    paginationValue: null,
    replaceModeEnabled: false
  },
  {
    name: 'Demographics',
    fieldName: 'deltaDemographics',
    label: 'DEMOGRAPHICS',
    displaySwitch: true,
    threshold: null,
    active: true,
    importToBeDeleted: false,
    paginationValue: null,    
    isOneRosterApi: false
  },
  {
    name: 'Academic Sessions',
    fieldName: 'deltaAcademicSessions',
    label: 'ACADEMIC SESSIONS',
    displaySwitch: false,
    threshold: null,
    active: true,
    importToBeDeleted: false,
    paginationValue: null,
    isOneRosterApi: false,
    replaceModeEnabled: false
  },
  {
    name: 'Resources',
    fieldName: 'deltaResources',
    label: 'RESOURCES',
    displaySwitch: true,
    threshold: null,
    active: true,
    paginationValue: null,
    importToBeDeleted: false,
    isOneRosterApi: false,
    replaceModeEnabled: false
  },
  {
    name: 'Class Resources',
    fieldName: 'deltaClassResources',
    label: 'CLASS RESOURCES',
    displaySwitch: true,
    threshold: null,
    active: true,
    paginationValue: null,
    importToBeDeleted: false,
    isOneRosterApi: false,
    replaceModeEnabled: false

  },
  {
    name: 'Course Resources',
    fieldName: 'deltaCourseResources',
    label: 'COURSE RESOURCES',
    displaySwitch: true,
    threshold: null,
    active: true,
    paginationValue: null,
    importToBeDeleted: false,
    isOneRosterApi: false,
    replaceModeEnabled: false
  },{
    name: 'Line Items',
    fieldName: 'deltaLineItems',
    label: 'LINE ITEMS',
    displaySwitch: true,
    threshold: null,
    active: false,
    paginationValue: null,
    importToBeDeleted: false,
    isOneRosterApi: true

  },{
    name: 'Results',
    fieldName: 'deltaResults',
    label: 'RESULTS',
    displaySwitch: true,
    threshold: null,
    active: false,
    paginationValue: null,
    importToBeDeleted: false,
    isOneRosterApi: true
  },{
    name: 'Categories',
    fieldName: 'deltaCategories',
    label: 'CATEGORIES',
    displaySwitch: true,
    threshold: null,
    active: false,
    paginationValue: null,
    importToBeDeleted: false,
    isOneRosterApi: true
  },{ 
    name: 'Enrollments',
    fieldName: 'deltaEnrollments',
    label: 'ENROLLMENTS',
    displaySwitch: false,
    threshold: null,
    active: true,
    paginationValue: null,
    importToBeDeleted: false,
    isOneRosterApi: true
  },
];

export default OBJECT_TYPES;



// WEBPACK FOOTER //
// ./app/models/objectTypes.js